import moment from 'moment';
import { forEach, filter, reduce } from 'lodash';

import './date-picker.style.sass';
import template from './date-picker.tpl.pug';

class DatePickerController {
    /* @ngInject */
    constructor(timeUtil) {
        this.timeUtil = timeUtil;
    }

    $onInit() {
        this.weekdays = this.timeUtil.getWeekdays(this.startOfWeek).map((day) => {
            return {
                name: moment(day.timestamp).format('ddd'),
                weekend: day.weekend
            };
        });
    }

    $onChanges(changeObject) {
        if (changeObject.date) {
            this.selectedTimestamp = moment(this.date).startOf('day').valueOf();
        }

        if (changeObject.viewTimestamp || changeObject.date) {
            this.renderMonth(this.viewTimestamp || this.selectedTimestamp);
        }
    }

    renderMonth(viewTimestamp) {
        this.viewTimestamp = moment(viewTimestamp).startOf('day').valueOf();
        this.monthName = moment(this.viewTimestamp).format('MMMM YYYY');

        this.weeks = this.createWeeks(this.viewTimestamp);
    }

    changeMonth(viewTimestamp) {
        this.renderMonth(viewTimestamp);

        this.onViewChange({
            timestamp: this.viewTimestamp
        });
    }

    createWeeks(viewTimestamp) {
        let weeks = [];

        let now = moment();

        forEach(this.timeUtil.getDaysForMonth(viewTimestamp, this.startOfWeek, 42), (day, index) => {
            index = Math.floor(index / 7);

            if (index >= weeks.length) {
                weeks.push([]);
            }

            let item = {
                timestamp: moment(day.timestamp).set({
                    hour: now.get('hour'),
                    minute: now.get('minute'),
                    second: now.get('second')
                }).valueOf(),
                date: moment(day.timestamp).date(),
                style: {
                    active: this.checkActive(this.selectedTimestamp, day),
                    weekend: day.weekend,
                    another: day.previous || day.next,
                    today: day.today,
                    highlighted: this.onDayCheckHighlighted({
                        timestamp: day.timestamp
                    }),
                    disabled: this.onDayCheckDisabled({
                        timestamp: day.timestamp
                    })
                }
            };

            item.style.hidden = this.hideDaysFromOtherMonth && item.style.another;

            weeks[index].push(item);
        });

        forEach(weeks, (week) => {
            forEach(week, (day, index) => {
                if (day.style.highlighted) {
                    day.style['first-highlighted'] = index === 0 || !week[index - 1].style.highlighted || week[index - 1].style.hidden;
                    day.style['last-highlighted'] = index === week.length - 1 || !week[index + 1].style.highlighted || week[index + 1].style.hidden;
                }
            });
        });

        return this.filterHiddenWeeks(weeks);
    }

    filterHiddenWeeks(weeks) {
        return filter(weeks, (week) => {
            let hiddenDayCount = reduce(week, (count, day) => {
                if (day.style.hidden) {
                    return count + 1;
                }

                return count;
            }, 0);

            return hiddenDayCount < week.length;
        });
    }

    selectPreviousMonth() {
        this.changeMonth(moment(this.viewTimestamp).subtract(1, 'month').valueOf());
    }

    selectNextMonth() {
        this.changeMonth(moment(this.viewTimestamp).add(1, 'month').valueOf());
    }

    checkActive(timestamp, day) {
        let active = this.onDayCheckActive({
            timestamp: day.timestamp
        });

        return active == null
            ? timestamp === day.timestamp
            : active;
    }

    selectDay(timestamp) {
        return this.onDaySelect({
            timestamp
        });
    }
}

export default {
    selector: 'dbADatePicker',
    template: template(),
    controller: DatePickerController,
    bindings: {
        date: '<timestamp',
        startOfWeek: '<',
        viewTimestamp: '<',

        preventNavigationToPreviousMonth: '<',
        preventNavigationToNextMonth: '<',
        hideDaysFromOtherMonth: '<',

        onDaySelect: '&',
        onDayCheckActive: '&',
        onDayCheckDisabled: '&',
        onDayCheckHidden: '&',
        onDayCheckHighlighted: '&',
        onViewChange: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/date-picker/date-picker.cmpt.js